import React, { useState } from 'react';

// Mock data for timetable
const mockTimeSlots = [
  '08:00 - 08:45',
  '08:45 - 09:30',
  '09:30 - 10:15',
  '10:15 - 10:30', // Break
  '10:30 - 11:15',
  '11:15 - 12:00',
  '12:00 - 12:45',
  '12:45 - 13:30', // Lunch
  '13:30 - 14:15',
  '14:15 - 15:00'
];

const mockTimetableData = {
  'Grade 10A': {
    Monday: [
      { subject: 'Mathematics', teacher: 'Mr. Chen', room: 'Room 101' },
      { subject: 'English', teacher: 'Ms. Rodriguez', room: 'Room 102' },
      { subject: 'Physics', teacher: 'Dr. Wilson', room: 'Lab 1' },
      { subject: 'Break', teacher: '', room: '' },
      { subject: 'Chemistry', teacher: 'Dr. Smith', room: 'Lab 2' },
      { subject: 'History', teacher: 'Ms. Johnson', room: 'Room 103' },
      { subject: 'Geography', teacher: 'Mr. Brown', room: 'Room 104' },
      { subject: 'Lunch', teacher: '', room: '' },
      { subject: 'Art', teacher: 'Ms. Davis', room: 'Art Room' },
      { subject: 'PE', teacher: 'Mr. Wilson', room: 'Gym' }
    ],
    Tuesday: [
      { subject: 'English', teacher: 'Ms. Rodriguez', room: 'Room 102' },
      { subject: 'Mathematics', teacher: 'Mr. Chen', room: 'Room 101' },
      { subject: 'Biology', teacher: 'Dr. Green', room: 'Lab 3' },
      { subject: 'Break', teacher: '', room: '' },
      { subject: 'History', teacher: 'Ms. Johnson', room: 'Room 103' },
      { subject: 'Physics', teacher: 'Dr. Wilson', room: 'Lab 1' },
      { subject: 'Computer Science', teacher: 'Mr. Tech', room: 'Computer Lab' },
      { subject: 'Lunch', teacher: '', room: '' },
      { subject: 'Music', teacher: 'Ms. Melody', room: 'Music Room' },
      { subject: 'Study Hall', teacher: 'Various', room: 'Library' }
    ],
    Wednesday: [
      { subject: 'Physics', teacher: 'Dr. Wilson', room: 'Lab 1' },
      { subject: 'Chemistry', teacher: 'Dr. Smith', room: 'Lab 2' },
      { subject: 'Mathematics', teacher: 'Mr. Chen', room: 'Room 101' },
      { subject: 'Break', teacher: '', room: '' },
      { subject: 'English', teacher: 'Ms. Rodriguez', room: 'Room 102' },
      { subject: 'Geography', teacher: 'Mr. Brown', room: 'Room 104' },
      { subject: 'PE', teacher: 'Mr. Wilson', room: 'Gym' },
      { subject: 'Lunch', teacher: '', room: '' },
      { subject: 'Art', teacher: 'Ms. Davis', room: 'Art Room' },
      { subject: 'Biology', teacher: 'Dr. Green', room: 'Lab 3' }
    ],
    Thursday: [
      { subject: 'Mathematics', teacher: 'Mr. Chen', room: 'Room 101' },
      { subject: 'History', teacher: 'Ms. Johnson', room: 'Room 103' },
      { subject: 'English', teacher: 'Ms. Rodriguez', room: 'Room 102' },
      { subject: 'Break', teacher: '', room: '' },
      { subject: 'Computer Science', teacher: 'Mr. Tech', room: 'Computer Lab' },
      { subject: 'Chemistry', teacher: 'Dr. Smith', room: 'Lab 2' },
      { subject: 'Geography', teacher: 'Mr. Brown', room: 'Room 104' },
      { subject: 'Lunch', teacher: '', room: '' },
      { subject: 'Music', teacher: 'Ms. Melody', room: 'Music Room' },
      { subject: 'Study Hall', teacher: 'Various', room: 'Library' }
    ],
    Friday: [
      { subject: 'Biology', teacher: 'Dr. Green', room: 'Lab 3' },
      { subject: 'Physics', teacher: 'Dr. Wilson', room: 'Lab 1' },
      { subject: 'Mathematics', teacher: 'Mr. Chen', room: 'Room 101' },
      { subject: 'Break', teacher: '', room: '' },
      { subject: 'English', teacher: 'Ms. Rodriguez', room: 'Room 102' },
      { subject: 'Art', teacher: 'Ms. Davis', room: 'Art Room' },
      { subject: 'PE', teacher: 'Mr. Wilson', room: 'Gym' },
      { subject: 'Lunch', teacher: '', room: '' },
      { subject: 'History', teacher: 'Ms. Johnson', room: 'Room 103' },
      { subject: 'Assembly', teacher: 'All Staff', room: 'Auditorium' }
    ]
  }
};

const mockClasses = ['Grade 9A', 'Grade 9B', 'Grade 10A', 'Grade 10B', 'Grade 11A', 'Grade 11B', 'Grade 12A'];

const TimeTablePage = () => {
  const [selectedClass, setSelectedClass] = useState('Grade 10A');
  const [viewMode, setViewMode] = useState('weekly'); // weekly, daily
  const [selectedDay, setSelectedDay] = useState('Monday');
  const [showEditModal, setShowEditModal] = useState(false);

  const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  const getSubjectColor = (subject) => {
    const colors = {
      'Mathematics': 'bg-blue-100 text-blue-800 border-blue-200',
      'English': 'bg-green-100 text-green-800 border-green-200',
      'Physics': 'bg-purple-100 text-purple-800 border-purple-200',
      'Chemistry': 'bg-red-100 text-red-800 border-red-200',
      'Biology': 'bg-emerald-100 text-emerald-800 border-emerald-200',
      'History': 'bg-yellow-100 text-yellow-800 border-yellow-200',
      'Geography': 'bg-orange-100 text-orange-800 border-orange-200',
      'Computer Science': 'bg-indigo-100 text-indigo-800 border-indigo-200',
      'Art': 'bg-pink-100 text-pink-800 border-pink-200',
      'Music': 'bg-violet-100 text-violet-800 border-violet-200',
      'PE': 'bg-teal-100 text-teal-800 border-teal-200',
      'Study Hall': 'bg-gray-100 text-gray-800 border-gray-200',
      'Assembly': 'bg-slate-100 text-slate-800 border-slate-200',
      'Break': 'bg-amber-50 text-amber-600 border-amber-200',
      'Lunch': 'bg-amber-50 text-amber-600 border-amber-200'
    };
    return colors[subject] || 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const currentTimetable = mockTimetableData[selectedClass] || {};

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Time Table Management</h1>
        <p className="text-gray-600">Manage class schedules and time slots for all grades</p>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-blue-100 text-blue-600 text-xl">📅</div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total Classes</p>
              <p className="text-2xl font-bold text-gray-900">{mockClasses.length}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-green-100 text-green-600 text-xl">⏰</div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Time Slots</p>
              <p className="text-2xl font-bold text-gray-900">{mockTimeSlots.length}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-purple-100 text-purple-600 text-xl">📚</div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Subjects</p>
              <p className="text-2xl font-bold text-gray-900">12</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-orange-100 text-orange-600 text-xl">🏫</div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Rooms</p>
              <p className="text-2xl font-bold text-gray-900">15</p>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Class and View Selection */}
          <div className="flex gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Class</label>
              <select
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              >
                {mockClasses.map(cls => (
                  <option key={cls} value={cls}>{cls}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">View</label>
              <select
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="weekly">Weekly View</option>
                <option value="daily">Daily View</option>
              </select>
            </div>

            {viewMode === 'daily' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Day</label>
                <select
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                >
                  {weekDays.map(day => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={() => setShowEditModal(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center gap-2"
            >
              <span>✏️</span>
              Edit Schedule
            </button>
            <button className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center gap-2">
              <span>📄</span>
              Export PDF
            </button>
            <button className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 flex items-center gap-2">
              <span>📋</span>
              Copy Schedule
            </button>
          </div>
        </div>
      </div>

      {/* Timetable Display */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">
            {selectedClass} - {viewMode === 'weekly' ? 'Weekly Schedule' : `${selectedDay} Schedule`}
          </h3>
        </div>

        {viewMode === 'weekly' ? (
          // Weekly View
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-32">
                    Time
                  </th>
                  {weekDays.map(day => (
                    <th key={day} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      {day}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {mockTimeSlots.map((timeSlot, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 bg-gray-50">
                      {timeSlot}
                    </td>
                    {weekDays.map(day => {
                      const subject = currentTimetable[day]?.[index];
                      return (
                        <td key={day} className="px-4 py-3">
                          {subject ? (
                            <div className={`p-3 rounded-lg border ${getSubjectColor(subject.subject)}`}>
                              <div className="font-medium text-sm">{subject.subject}</div>
                              {subject.teacher && (
                                <div className="text-xs opacity-75">{subject.teacher}</div>
                              )}
                              {subject.room && (
                                <div className="text-xs opacity-75">{subject.room}</div>
                              )}
                            </div>
                          ) : (
                            <div className="p-3 rounded-lg border border-dashed border-gray-300 text-gray-400 text-center text-sm">
                              Free
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          // Daily View
          <div className="p-6">
            <div className="space-y-4">
              {mockTimeSlots.map((timeSlot, index) => {
                const subject = currentTimetable[selectedDay]?.[index];
                return (
                  <div key={index} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg hover:bg-gray-50">
                    <div className="w-32 text-sm font-medium text-gray-900">
                      {timeSlot}
                    </div>
                    <div className="flex-1">
                      {subject ? (
                        <div className={`p-4 rounded-lg border ${getSubjectColor(subject.subject)}`}>
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="font-medium text-lg">{subject.subject}</div>
                              {subject.teacher && (
                                <div className="text-sm opacity-75">Teacher: {subject.teacher}</div>
                              )}
                              {subject.room && (
                                <div className="text-sm opacity-75">Room: {subject.room}</div>
                              )}
                            </div>
                            <div className="flex space-x-2">
                              <button className="text-blue-600 hover:text-blue-900" title="Edit">✏️</button>
                              <button className="text-red-600 hover:text-red-900" title="Remove">🗑️</button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="p-4 rounded-lg border border-dashed border-gray-300 text-gray-400 text-center">
                          <span>No class scheduled</span>
                          <button className="ml-2 text-blue-600 hover:text-blue-900">+ Add Subject</button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Quick Actions */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">📚 Subject Management</h3>
          <p className="text-gray-600 text-sm mb-4">Add, edit, or remove subjects from the curriculum</p>
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
            Manage Subjects →
          </button>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">👥 Teacher Assignment</h3>
          <p className="text-gray-600 text-sm mb-4">Assign teachers to subjects and manage substitutions</p>
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
            Assign Teachers →
          </button>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">🏫 Room Allocation</h3>
          <p className="text-gray-600 text-sm mb-4">Manage classroom and laboratory allocations</p>
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
            Manage Rooms →
          </button>
        </div>
      </div>

      {/* Edit Schedule Modal Placeholder */}
      {showEditModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Edit Schedule</h3>
              <p className="text-gray-500 mb-4">Schedule editing interface will be implemented here.</p>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowEditModal(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => setShowEditModal(false)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeTablePage; 